import { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useFormContext } from "react-hook-form";
import { Button } from "components/Button";
import { useTranslation } from "react-i18next";

const SignaturePad = () => {
  const ref = useRef<any>(null);
  const { setValue, watch } = useFormContext();

  const { t } = useTranslation();

  const save = () => {
    const data = ref.current.toDataURL();
    ref.current.clear();
    setValue("signature", data);
  };

  return (
    <div className="border rounded w-full h-full flex flex-col justify-between">
      <SignatureCanvas
        ref={ref}
        penColor="black"
        canvasProps={{ className: "w-full h-[70%]" }}
      />
      <div className={"flex flex-col flex-1 justify-end gap-y-1"}>
        {watch("signature") && (
          <img
            src={watch("signature")}
            alt="signature"
            className={
              "w-[70px] h-[70px] object-contain border rounded border-primary-80"
            }
          />
        )}
        <Button onClick={save} variant={"outlined"}>
          {watch("signature") ? t("reset") : t("approve")}
        </Button>
      </div>
    </div>
  );
};

export default SignaturePad;
